export default __webpack_public_path__ + "static/media/Netflix_Logo.edc29071.png";